import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { DropdownButton, MenuItem, OverlayTrigger, Popover } from 'react-bootstrap';
import * as actions from 'modules/orders';
import * as account from 'modules/account';
import { injectIntl } from 'react-intl';
import FulfillOrderDialog from './FulfillOrderDialog';
import DeliveryFailuresDialog from './DeliveryFailuresDialog';
import moment from 'moment';
import InvoiceEditorDialog from './InvoiceEditorDialog';
import { reset } from 'redux-form';
import { shopifyService } from 'services';
import { isCustomerInvoiceExcluded } from 'utils/customerInvoiceExclusions';

function nameFormatter(cell, row) {
    let { intl } = this.props;
    const t = (id) => intl.formatMessage({ id });
    if (!row.customer)
        return <span className="text-muted">{t('orderList.noCustomer')}</span>;
    let customerName = (row.customer.first_name !== null ? row.customer.first_name : '')
        + ' ' + (row.customer.last_name !== null ? row.customer.last_name : '')

    if (customerName === ' ') {
        return <span className="text-muted">{t('orderList.noCustomer')}</span>;
    }
    return  (<input style={{border:'none'}} type="text" value= {customerName} />);

}


function showFulfillmentDialog(row, e) {
    this.fulFillOrderDialog.wrappedInstance.show(row);
    e.preventDefault();
    e.stopPropagation();
}
function orderNameFormatter(cell, row) {

    let { fetching, user, dispatch, intl } = this.props;
    const t = (id) => intl.formatMessage({ id });
    let { themes } = user;
    let defaultThemes = themes.filter((t) => t.isPrimary === true);
    let defaultTheme = defaultThemes.length > 0 ? defaultThemes[defaultThemes.length - 1].name : 'order';

    return <span>
            <button className="btn btn-sm btn-grid-sm btn-default" onClick={!fetching && showFulfillmentDialog.bind(this, row)}>{cell}</button>
            &nbsp;
            <button title={t('orderList.downloadOrder')} className="btn btn-sm btn-grid-sm btn-default" onClick={() => {
                    window.open(`/template/${defaultTheme}/download?id=${row.id}&shop=${row.shop_name}.myshopify.com`, "_blank");
                }}>
                <i className="fa fa-download"></i>
            </button>
            {row && row.invoice_number && <button type="button" className="btn btn-sm btn-grid-sm btn-default" title={t('orderList.revertToDate')} onClick={()=>{
                var r = confirm(`${t('orderList.deleteWarning')} ${moment(row.date_created).format('MM/DD/YYYY h:mm A')}, ${t('orderList.includingInvoice')}${row.invoice_number}. ${t('orderList.pressOk')}`);
                if (r == true) {
                    let location = getLocationById(user, getOrderLocationId(user, row));

                    if (location)
                        dispatch(account.revertSystem(row.date_created, location.locationId));
                    else
                        dispatch(account.revertSystem(row.date_created));
                }
            }}><i className="fa fa-undo"></i></button>}
        </span>
}

function getOrderLocationId(user, order) {

    let fulfillments = order.fulfillments || [];
    let fulfillment = fulfillments.length > 0 ? fulfillments[0] : {};
    let order_location_id =  fulfillment.location_id || order.location_id || null;


    if (user && user.hasMultipleLocations) {
        for (let i = 0; i < user.locations.length; i++) {
            if (user.locations[i].default === true) {
                return Number(user.locations[i].locationId); //override with first default
            }
        }

        for (let i = 0; order && i < user.locations.length; i++) {
            if ((user.match === "shipping_address.country_code" && order.shipping_address && user.locations[i].accounting.country === order.shipping_address.country_code)
                ||
                (user.match === "billing_address.country_code" && order.billing_address && user.locations[i].accounting.country === order.billing_address.country_code)) {
                return Number(user.locations[i].locationId); //override with first default
            }

            if (user.match === "location_id") {
                if (Number(user.locations[i].locationId) === Number(order_location_id))
                    return Number(user.locations[i].locationId);
            }
        }

        if (user.locations.length > 0)
            return Number(user.locations[0].locationId); //not found, use location 0.
    }

    return order_location_id;

}

function getLocationById(user, locationId) {
    if (!user.locations)
        return null;

    for (let i = 0; i < user.locations.length; i++) {
        if (Number(user.locations[i].locationId) === Number(locationId)) {
            return user.locations[i];
        }
    }

    return null;
}

let locations = null;

function getLocationName(locationId){
    for (let i = 0; i< locations.length; i++){
        if (locations[i].id === Number(locationId)){
            return " - " + locations[i].name;
        }
    }

    return '';
}

function invoiceNumberFormatter(cell, row) {
    let showEditor = (order, isUpdate, key) => {
        this.dispatch(reset('InvoiceEditor'))
        this.dispatch(actions.selectOrder(order, typeof key === "string" && key !== 'storno', isUpdate, false))
        this._invoiceEditor.getWrappedInstance().wrappedInstance.show();

        return false;
    }
    let saveChanges = (form) => {
        this.dispatch(actions.updateInvoice({ invoice: form }, this.list.props.filter));
        this._invoiceEditor.getWrappedInstance().wrappedInstance.hide();
    }

    let { user } = this;
    let { themes } = user;
    const t = (id) => this.intl.formatMessage({ id });

    let location = getLocationById(user, getOrderLocationId(user, row));


    let disableCreate = user.hasMultipleLocations && location ? !location.enabled : false;
    let customerInvoicingDisabled = isCustomerInvoiceExcluded(user, row.customer && row.customer.id);
    return (
        <div>
            <InvoiceEditorDialog
                title={t('orderList.refund')}
                submitButtonLabel={t('orderList.add')}
                isValidDate={this.isValidDate}
                currentInvoiceDate={this.currentInvoiceDate}
                ref={(i) => this._invoiceEditor = i} {...this.props}
                onOk={saveChanges.bind(this)}
            />
            {row.processing ? <div><i className="fa fa-spin fa-circle-o-notch"></i></div> :
                <div>
                    {cell ? <div>
                        <button onClick={showEditor.bind(this.list, row, true)} title={'#' + cell}
                            className={row.has_storno ? "btn btn-sm btn-grid-sm btn-danger btn-order-edit" : "btn btn-sm btn-grid-sm btn-default btn-order-edit"}>
                            <i className="fa fa-pencil"></i>&nbsp;#{cell}
                        </button>

                        {themes.length === 0 ? <button title={t('orderList.downloadInvoice')} onClick={(e) => {
                            window && window.open(`${window ? window.location.origin : ''}/invoice/${this.user.shopify.shopName}/${btoa(`$${row.id}$false`)}`, "_blank");
                        }} className="btn btn-success btn-sm btn-grid-sm"
                            type="button">
                            <i className="fa fa-download"></i><span className="sr-only">{t('orderList.download')}</span>
                            </button> :

                            <DropdownButton id="download-dd" onClick={(e) => {
                                e.stopPropagation();
                            }}
                                className="btn btn-success btn-sm btn-grid-sm"
                                title={<span title={t('orderList.download')}><i className="fa fa-download"></i><span className="sr-only">{t('orderList.download')}</span></span>}
                                onSelect={(theme) => {
                                    window.open(`/template/${theme}/download?id=${row.id}&shop=${row.shop_name}.myshopify.com`, "_blank");
                                }}
                            >
                                {/* Show legacy template for old users at TOP */}
                                {!this.user.dateCreated &&
                                    <MenuItem eventKey="default" style={{color: '#999', fontStyle: 'italic'}}>
                                        {this.intl.formatMessage({ id: 'orderList.legacyTemplate' })}
                                    </MenuItem>
                                }
                                {
                                    themes.filter(t => t.documentType !== "refund" && t.documentType !== "credit-note" && t.documentType !== "storno").sort((a, b) => a.isPrimary === b.isPrimary ? -1 : 0).map((t) => {
                                        return <MenuItem eventKey={t.name}>{(t.isPrimary ? `${t.name} - ${this.intl.formatMessage({ id: 'orderList.default' })}` : t.name)  + getLocationName(t.locationId)}</MenuItem>
                                    })
                                }
                            </DropdownButton>}

                    </div> :
                        <button type="button" onClick={(e) => {
                            this.list.props.onCreate(row);
                            e.stopPropagation();
                        }} disabled={(this.user.profile.subscription !== "free" && this.user.autoInvoicingMode !== "manual") || this.fetching || disableCreate || customerInvoicingDisabled}
                            title={customerInvoicingDisabled
                                ? this.intl.formatMessage({ id: 'orderList.cannotCreateCustomerInvoicing', defaultMessage: 'Invoicing is disabled for this customer.' })
                                : (this.user.autoInvoicingMode !== "manual" ? t('orderList.cannotCreateAutopilot') : t('orderList.createInvoice'))}
                            className="btn btn-default btn-sm btn-grid-sm btn-create">
                            <i className="fa fa-plus"></i>&nbsp;{t('orderList.create')}
                </button>
                    }
                </div>}

        </div>
    );
}

class CancelDropDown extends Component {

    render() {
        let { user, fetching, order, onSelect, intl } = this.props;
        const t = (id) => intl.formatMessage({ id });
        return <DropdownButton id="refund-dd" onClick={(e) => {
            e.stopPropagation();
        }}
            className="btn btn-danger btn-sm btn-grid-sm"
            title={t('orderList.refund')}
            disabled={fetching}
            onSelect={onSelect}
        >

            <MenuItem disabled={fetching} eventKey="credit-note">{t('orderList.addCreditNote')}</MenuItem>
            <MenuItem disabled={fetching} eventKey="storno">{t('orderList.createStorno')}</MenuItem>
        </DropdownButton>
    }
}

function stornoNumberFormatter(cell, row) {

    let onSelect = (order, isUpdate, key) => {
        this.dispatch(reset('InvoiceEditor'))
        this.dispatch(actions.selectOrder(order, key === "credit-note" || order.has_credit_note, isUpdate, true))
        this._refundEditor.getWrappedInstance().wrappedInstance.show();

        return false;
    }
    let addRefund = (form) => {
        this.onStorno(form, form.has_credit_note);
        this._refundEditor.getWrappedInstance().wrappedInstance.hide();
    }

    let { user } = this;
    let { themes } = user;
    const t = (id) => this.intl.formatMessage({ id });

    if (user.useOrderNumbering && !user.hasMultipleLocations)
        cell = cell+"R";

    if (user.hasMultipleLocations){

        let locId = getOrderLocationId(user, row);
        let loc = getLocationById(user, locId);

        if (loc && loc.useOrderNumbering)
            cell = cell+"R";
    }

    return (
        <div>
            <InvoiceEditorDialog
                title={t('orderList.refund')}
                submitButtonLabel={t('orderList.add')}
                isValidDate={this.isValidDate}
                currentInvoiceDate={this.currentInvoiceDate}
                ref={(i) => this._refundEditor = i} {...this.props}
                onOk={addRefund.bind(this)}
            />

            {row.processing ?
                <div></div> :
                <div>{cell && row.has_storno ? <div><button onClick={onSelect.bind(this.list, row, true)} title={row.has_credit_note ? 'CN#' + (row.refund_order.storno_number || cell) : '#' + cell}
                    className={row.has_storno ? "btn btn-danger btn-sm btn-grid-sm pointer" : "label btn-grid-sm label-default"}>
                    <i className="fa fa-pencil"></i>&nbsp;{row.has_credit_note ? 'CN#' + (row.refund_order.storno_number || cell) : '#' + cell}</button>

                    {themes.length === 0?
                     <button title={t('orderList.downloadStorno')} onClick={(e) => {
                        window && window.open(`${window ? window.location.origin : ''}/invoice/${this.user.shopify.shopName}/${btoa(`$${row.id}$true`)}`, "_blank");
                    }} className="btn btn-success btn-sm btn-grid-sm"
                        type="button">
                        <i className="fa fa-download"></i><span className="sr-only">{t('orderList.download')}</span>
                                </button>
                                :
                                <DropdownButton id="download-dd" onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                    className="btn btn-success btn-sm btn-grid-sm"
                                    title={<span title={t('orderList.download')}><i className="fa fa-download"></i><span className="sr-only">{t('orderList.download')}</span></span>}
                                    onSelect={(theme) => {
                                        window.open(`/template/${theme}/download/?id=${row.id}&shop=${row.shop_name}.myshopify.com&storno=true`, "_blank");
                                    }}
                                >
                                    {/* Show legacy template for old users at TOP */}
                                    {!this.user.dateCreated &&
                                        <MenuItem eventKey="default" style={{color: '#999', fontStyle: 'italic'}}>
                                            {this.intl.formatMessage({ id: 'orderList.legacyTemplate' })}
                                        </MenuItem>
                                    }
                                    {
                                        themes.filter(t => t.documentType === "refund" || t.documentType === "credit-note" || t.documentType === "storno" || t.documentType === "" || !t.documentType).sort((a, b) => a.isPrimary === b.isPrimary ? -1 : 0).map((t) => {
                                            return <MenuItem eventKey={t.name}>{(t.isPrimary ? `${t.name} - ${this.intl.formatMessage({ id: 'orderList.default' })}` : t.name)  + getLocationName(t.locationId)}</MenuItem>
                                        })
                                    }
                                </DropdownButton>
                    }

                </div> :
                    row.invoice_number && <CancelDropDown user={this.user} fetching={this.fetching} intl={this.intl} onSelect={onSelect.bind(this.list, row, false)} dispatch={this.dispatch} onStorno={this.list.props.onStorno} order={row}>
                    </CancelDropDown>}
                </div>
            }
        </div>
    );
}


function formatCompactDate(intl, date) {
    const d = new Date(date);
    if (d.getFullYear() === new Date().getFullYear()) {
        return intl.formatDate(d, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    }
    return intl.formatDate(d, { month: 'short', day: 'numeric', year: 'numeric' });
}

class DateFormatter extends React.Component {
    render() {
        const { date, intl } = this.props;
        return (<input style={{border:'none'}} type="text" title={date ? moment(date).format('MM/DD/YYYY h:mm A') : ''} value={date ? formatCompactDate(intl, date) : "-"} />
       
        );
    }
}

function dateFormatter(cell, row) {
    return (
        <DateFormatter date={cell} intl={this.props.intl} />
    );
}
function stornoDateFormatter(cell, row) {
    return (
        <DateFormatter date={row.has_storno ? cell : ''} intl={this.props.intl} />
    );
}

function fulfillmentStatusFormatter(cell, row) {
    let { intl } = this.props;
    const t = (id) => intl.formatMessage({ id });
    let label = cell === 'fulfilled' ? t('orderList.fulfilled') : t('orderList.unfulfilled');
    return (
        <label className={cell === 'fulfilled' ? "label label-default" : "label label-warning"}>{label}</label>
    );
}

function paidStatusFormatter(cell, row) {
    let { intl } = this.props;
    const t = (id) => intl.formatMessage({ id });

    if (row.is_paid) {
        return <label className={"label label-default"}>{t('orderList.paidManual')}</label>
    }

    if (cell === 'paid' || row.is_paid) {
        return <label className={"label label-default"}>{t('orderList.paid')}</label>
    }
    if (cell === 'refunded') {
        return <label className={"label label-default"}>{t('orderList.refunded')}</label>
    }
    if (cell === 'pending') {
        return <label className={"label label-warning"}>{t('orderList.pending')}</label>
    }
    if (cell === 'partially_paid') {
        return <label className={"label label-warning"}>{t('orderList.partiallyPaid')}</label>
    }

    if (cell === 'partially_refunded') {
        return <label className={"label label-warning"}>{t('orderList.partiallyRefunded')}</label>
    }

    return <label className="label label-default text-capitalize">{cell && cell.replace(/_/g, ' ')}</label>
}

function locationFormatter(cell, row) {
    let { user } = this.props;

    let location = getLocationById(user, getOrderLocationId(user, row));

    if (location)
        return location.invoicePrefix;

    return '';
}

function getThemeNameForOrder(user, isStorno) {
    let themes = (user && user.themes) || [];
    if (isStorno) {
        let stornoThemes = themes.filter(t => t.documentType === 'refund' || t.documentType === 'credit-note' || t.documentType === 'storno');
        let primary = stornoThemes.find(t => t.isPrimary);
        return (primary || stornoThemes[0] || {}).name || 'order';
    }
    let primary = themes.find(t => t.isPrimary && (!t.documentType || t.documentType === 'invoice' || t.documentType === ''));
    return (primary || themes[0] || {}).name || 'order';
}

function deliveryStatusFormatter(cell, row) {
    let { dispatch, filter, user, intl } = this;
    const t = (id) => intl.formatMessage({ id });
    if (!row.invoice_number) return <span></span>;
    if (cell === null || cell === undefined) {
        return <span>
            <label className="label label-default">{t('orderList.deliveryPending')}</label>{' '}
            <label className="label label-primary" style={{cursor:'pointer'}} title={t('orderList.deliverNow')} onClick={(e) => {
                e.stopPropagation();
                dispatch(actions.deliverInvoice(row.id, false, filter));
            }}><i className="fa fa-paper-plane"></i></label>
        </span>;
    }

    if (cell === true) {
        let channels = row.delivery_details && row.delivery_details.channels ? row.delivery_details.channels : [];
        let hasFailedChannel = channels.some(ch => ch.status === 'failed');
        let partialReason = row.delivery_details && row.delivery_details.reason ? row.delivery_details.reason : null;
        let invoiceThemeName = getThemeNameForOrder(user, false);
        let stornoThemeName = getThemeNameForOrder(user, true);
        let popover = <Popover id={`delivery-${row.id}`} title={t('orderList.deliveryDetails')} style={{minWidth:'360px', maxWidth:'420px'}}>
            <div style={{padding:'12px'}}>
            {(() => {
                let channelTypes = [];
                channels.forEach(ch => { if (!channelTypes.find(c => c.type === ch.type)) channelTypes.push(ch); });
                return channelTypes.map((chGroup, i) => {
                    let chsOfType = channels.filter(c => c.type === chGroup.type);
                    let invoiceCh = chsOfType.find(c => c.docType === 'invoice') || chsOfType[0];
                    let stornoCh = chsOfType.find(c => c.docType === 'storno');
                    let channelLabel = chGroup.type === 'googleDrive' ? t('orderList.googleDrive') : chGroup.type === 'clientsTablet' ? t('orderList.clientsTablet') : chGroup.type === 'shippyPro' ? t('orderList.shippyPro') : chGroup.type === 'email' ? t('orderList.emailChannel') : chGroup.type === 'ftp' ? t('orderList.ftpChannel') : chGroup.type.charAt(0).toUpperCase() + chGroup.type.slice(1);
                    let channelIcon = chGroup.type === 'email' ? 'fa-envelope-o' : chGroup.type === 'googleDrive' ? 'fa-google' : chGroup.type === 'ftp' ? 'fa-server' : chGroup.type === 'clientsTablet' ? 'fa-tablet' : 'fa-truck';
                    let failed = chsOfType.some(c => c.status === 'failed');
                    return <div key={i} style={{marginBottom: i < channelTypes.length - 1 ? '12px' : 0}}>
                        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px'}}>
                            <span style={{fontSize:'12px', fontWeight:600, color:'#1e293b'}}>
                                <i className={`fa ${channelIcon}`} style={{marginRight:6, color:'#64748b'}}></i>
                                {channelLabel}
                            </span>
                            {failed
                                ? <span style={{fontSize:'11px', color:'#dc3545', fontWeight:500}}><i className="fa fa-times-circle"></i> {t('orderList.failed')}</span>
                                : <span style={{fontSize:'11px', color:'#22c55e', fontWeight:500}}><i className="fa fa-check-circle"></i> {t('orderList.sent')}</span>}
                        </div>
                        {chGroup.type === 'email' && invoiceCh.to && <div style={{fontSize:'11px', color:'#64748b', marginBottom:'6px', paddingLeft:'22px'}}>{t('orderList.toLabel')}: {invoiceCh.to}</div>}
                        {chGroup.type === 'ftp' && <div style={{fontSize:'11px', color:'#64748b', marginBottom:'6px', paddingLeft:'22px'}}>{invoiceCh.host}:{invoiceCh.port} ({invoiceCh.secure ? 'SFTP' : 'FTP'})</div>}
                        {chGroup.type === 'googleDrive' && <div style={{fontSize:'11px', color:'#64748b', marginBottom:'6px', paddingLeft:'22px'}}>{t('orderList.folderLabel')}: {invoiceCh.folder || 'Invoice Browse'}</div>}
                        <div style={{paddingLeft:'22px'}}>
                            <div style={{display:'flex', alignItems:'center', gap:'8px', padding:'4px 0'}}>
                                <a href={`/template/${invoiceThemeName}/download?id=${row.id}&shop=${row.shop_name}.myshopify.com`} target="_blank" style={{fontSize:'12px'}}><i className="fa fa-file-pdf-o" style={{color:'#dc3545', marginRight:4}}></i>{t('orderList.invoice')}</a>
                                {invoiceCh.fileId && <a href={`https://drive.google.com/file/d/${invoiceCh.fileId}/view`} target="_blank" style={{fontSize:'10px', color:'#64748b'}}><i className="fa fa-external-link"></i> {t('orderList.open')}</a>}
                            </div>
                            {(row.has_storno || row.has_credit_note) && <div style={{display:'flex', alignItems:'center', gap:'8px', padding:'4px 0'}}>
                                <a href={`/template/${stornoThemeName}/download?id=${row.id}&shop=${row.shop_name}.myshopify.com&storno=true`} target="_blank" style={{fontSize:'12px'}}><i className="fa fa-file-pdf-o" style={{color:'#dc3545', marginRight:4}}></i>{row.has_credit_note ? t('orderList.creditNote') : t('orderList.stornoLabel')}</a>
                                {stornoCh && stornoCh.fileId && <a href={`https://drive.google.com/file/d/${stornoCh.fileId}/view`} target="_blank" style={{fontSize:'10px', color:'#64748b'}}><i className="fa fa-external-link"></i> {t('orderList.open')}</a>}
                            </div>}
                        </div>
                    </div>;
                });
            })()}
            {partialReason && <div style={{fontSize:'11px', color:'#dc3545', borderTop:'1px solid #eee', paddingTop:'8px', marginTop:'12px'}}>
                <i className="fa fa-warning"></i> {partialReason}
            </div>}
            <div style={{borderTop:'1px solid #eee', paddingTop:'10px', marginTop:'12px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                {row.delivered_at && <span style={{fontSize:'11px', color:'#94a3b8'}}>
                    {moment(row.delivered_at).format('MM/DD/YYYY h:mm A')}
                </span>}
                <button className="btn btn-xs btn-default" onClick={(e) => {
                    e.stopPropagation();
                    dispatch(actions.deliverInvoice(row.id, false, filter));
                    if (row.has_storno || row.has_credit_note) {
                        dispatch(actions.deliverInvoice(row.id, true, filter));
                    }
                }}><i className="fa fa-repeat"></i> {t('orderList.deliverAgain')}</button>
            </div>
            </div>
        </Popover>;

        return <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover}>
            <label className={`label ${hasFailedChannel ? 'label-warning' : 'label-success'}`} style={{cursor:'pointer'}}>{hasFailedChannel ? t('orderList.deliveryPartial') : t('orderList.delivered')}</label>
        </OverlayTrigger>;
    }

    let reason = row.delivery_details && row.delivery_details.reason ? row.delivery_details.reason : t('orderList.unknown');
    let popover = <Popover id={`delivery-${row.id}`} title={t('orderList.deliveryFailed')}>
        <p style={{fontSize:'12px', margin:0}}>{reason}</p>
        <div style={{borderTop:'1px solid #eee', paddingTop:'6px', marginTop:'8px'}}>
            <button className="btn btn-xs btn-primary" onClick={(e) => {
                e.stopPropagation();
                dispatch(actions.deliverInvoice(row.id, false, filter));
            }}><i className="fa fa-paper-plane"></i> {t('orderList.deliverNow')}</button>
        </div>
    </Popover>;
    const deliveryErrored = /^Error/.test(reason);
    return <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover}>
        <label className={deliveryErrored ? 'label label-danger' : 'label label-warning'} style={{cursor:'pointer'}}>{t('orderList.notDelivered')}</label>
    </OverlayTrigger>;
}

function priceFormatter(cell, row) {
    let { user } = this.props;
    return `${parseFloat(cell).toFixed(user.decimalPlaces)} ${row.currency}`;
}

function getRefundsTotal(row) {
    return Number(row.total_outstanding);
}
function formatRefundsPrice(cell, row) {
    let { user } = this.props;
    let total = getRefundsTotal(row);

    let price = parseFloat(total).toFixed(user.decimalPlaces);
    return `${price} ${row.currency}`;
}

function formatNetPrice(cell, row) {
    let { user } = this.props;

    let total = getRefundsTotal(row);

    let price = parseFloat(Number(row.total_price) - Number(Number(total).toFixed(2))).toFixed(user.decimalPlaces);
    
    return `${price} ${row.currency}`;
}


class OrderList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            failureCount: null
        };
    }

    fulfillOrder(order) {
        let { dispatch, filter } = this.props;
        dispatch(actions.fulfillOrder(order, filter));
        this.fulFillOrderDialog.wrappedInstance.hide()
    }

    cancelFulfillments(order) {
        let { dispatch } = this.props;
        dispatch(actions.cancelAllFulfillments(order));
        this.fulFillOrderDialog.wrappedInstance.hide()
    }

    hideFulfillOrderDialog() {
        this.fulFillOrderDialog.wrappedInstance.hide();
    }

    rowClassNameFormat(row, rowIdx) {
        return row.cancelled_at !== null ? 'table-raw-order-cancelled' : '';
    }

    componentDidMount(){
        if (!locations){
            (async()=>{
                locations = await shopifyService().getLocations();
                locations = locations.data;
            })();   
        }
        this.fetchFailureCount();
    }

    componentDidUpdate(prevProps){
        if (prevProps.filter !== this.props.filter || prevProps.list !== this.props.list){
            this.fetchFailureCount();
        }
    }

    fetchFailureCount(){
        shopifyService().deliveryFailures({ offset: 0, limit: 1 }).then((response) => {
            const data = response.data || {};
            this.setState({ failureCount: typeof data.total === 'number' ? data.total : null });
        }).catch(() => {});
    }

    render() {
        let { list, next, previous, totalCount, intl, onSizePerPageList, onPageChange, page, sizePerPage, onRowSelect, onSelectAll, fetching, dispatch, isValidDate, currentInvoiceDate, filter, updateOrder, user } = this.props;
        const t = (id) => intl.formatMessage({ id });

        const selectRowProp = {
            mode: user && (user.hasMultipleLocations) ? 'none' : 'checkbox',
            onSelect: onRowSelect,
            onSelectAll: onSelectAll,
            clickToSelect: true,
            columnWidth: '44px'
        };

        /*if (user.profile && user.profile.subscription === 'free') {
            selectRowProp.mode = 'none';
        }*/

        let options = {
            noDataText: <div style={{ textAlign: 'center', color: 'grey' }}>
                {fetching && <h1><i className="fa fa-spin fa-circle-o-notch"></i></h1>}
                {list.length === 0 && !fetching && user && user.shopify && <h4>{t('orderList.noOrders')} <br /> {t('orderList.cannotCreateNoOrders')}<br /> {t('orderList.createOrdersFirst')} <br /><br /> <a className="btn btn-default" href={`https://${user.shopify.shopName}.myshopify.com/admin/draft_orders/new`} target="_blank">{t('orderList.createOrders')}</a></h4>}
            </div>,
            onPageChange: (nextPage) => {
                this.table.cleanSelected();
                onPageChange(nextPage);
            },
            onSizePerPageList: onSizePerPageList,
            sizePerPage: sizePerPage,
            sizePerPageList: [20],
            alwaysShowAllBtns: true,
            page: page,
            defaultSortName: 'name',
            defaultSortOrder: 'desc'
        }

        return <div id="all-orders">
            <style dangerouslySetInnerHTML={{
                __html: `
                .page-item{
                    display: none !important;
                }
                ${fetching ? `.page-item[title="next page"]>a.page-link,.page-item[title="previous page"]>a.page-link{
                    pointer-events: none;
                    background: #f9f9f9 !important;
                    color: gray !important;
                    border-color: gray !important;
                }`: ``}
                .active.page-item{
                    display: initial !important;
                }

                .page-item[title="next page"],.page-item[title="previous page"]{
                    display: initial !important;
                }

                ${!next ? `.page-item[title="next page"]>a.page-link{
                    pointer-events: none;
                    opacity: 0.5;
                }`: ``}

                ${!previous ? `.page-item[title="previous page"]>a.page-link{
                    pointer-events: none;
                    opacity: 0.5;
                }`: ``}

            `}} >

            </style>
            <FulfillOrderDialog
                ref={instance => {
                    this.fulFillOrderDialog = instance
                }}
                user={user}
                onOk={this.fulfillOrder.bind(this)}
                onCancel={this.cancelFulfillments.bind(this)}
                dialogTitle={t('orderList.fulfillOrder')}
                dispatch={dispatch}
                closeButtonLabel={t('orderList.close')}
                isValidDate={isValidDate}
                filter={filter}
                updateOrder={updateOrder}
            />
            <DeliveryFailuresDialog
                ref={(instance) => {
                    this.deliveryFailuresDialog = instance;
                }}
                intl={intl}
                user={user}
                onRedelivered={() => {
                    this.fetchFailureCount();
                    dispatch(actions.fetchOrders(filter));
                }}
            />
            {list && locations && <BootstrapTable
                ref={instance => {
                    this.table = instance
                }}
                trClassName={this.rowClassNameFormat}
                selectRow={selectRowProp}
                headerContainerClass={fetching ? "campaign-list-header disabled" : "campaign-list-header"}
                options={options}
                data={list}
                hover
                fetchInfo={{ dataTotalSize: totalCount }}
                remote={true} pagination={true} >
                <TableHeaderColumn width='120' isKey dataField='name' dataSort dataFormat={orderNameFormatter.bind(this)} >{t('orderList.orderNum')}</TableHeaderColumn>
                {user.hasMultipleLocations && <TableHeaderColumn width='50' dataField='location_id' dataFormat={locationFormatter.bind(this)}>{t('orderList.locPrefix')}</TableHeaderColumn>}
                <TableHeaderColumn width='120' columnClassName="table-menu" dataField='invoice_number' dataFormat={invoiceNumberFormatter.bind({
                    user,
                    fetching,
                    list: this,
                    dispatch: dispatch,
                    intl: intl,
                    onStorno: this.props.onStorno,
                    isValidDate: isValidDate,
                    currentInvoiceDate: currentInvoiceDate
                })}>{t('orderList.invoiceNum')}</TableHeaderColumn>
                <TableHeaderColumn width='130' columnClassName="table-menu" dataField='storno_number' dataFormat={stornoNumberFormatter.bind({
                    user,
                    fetching,
                    list: this,
                    dispatch: dispatch,
                    intl: intl,
                    onStorno: this.props.onStorno,
                    isValidDate: isValidDate,
                    currentInvoiceDate: currentInvoiceDate
                })}>{t('orderList.refundNum')}</TableHeaderColumn>
                <TableHeaderColumn width='100' dataFormat={nameFormatter.bind(this)} >{t('orderList.customerCol')}</TableHeaderColumn>
                <TableHeaderColumn width='145' dataField='created_at' dataFormat={dateFormatter.bind(this)}>{t('orderList.orderCreatedDate')}</TableHeaderColumn>
                <TableHeaderColumn width='145' dataField='updated_at' dataFormat={dateFormatter.bind(this)}>{t('orderList.orderModifiedDate')}</TableHeaderColumn>
                <TableHeaderColumn width='108' dataField='delivered' dataFormat={deliveryStatusFormatter.bind({ dispatch, filter, user, intl })}>
                    {t('orderList.delivered')}{' '}
                    {this.state.failureCount > 0 && <span
                        className="label label-warning"
                        title={t('orderList.deliveryFailed')}
                        style={{cursor: 'pointer', marginLeft: '4px'}}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.deliveryFailuresDialog.show();
                        }}
                    >{this.state.failureCount}</span>}
                </TableHeaderColumn>
                <TableHeaderColumn width='110' dataField='financial_status' dataFormat={paidStatusFormatter.bind(this)}>{t('orderList.paymentStatus')}</TableHeaderColumn>
                <TableHeaderColumn width='90' dataField='fulfillment_status' dataFormat={fulfillmentStatusFormatter.bind(this)}>{t('orderList.fulfillmentStatus')}</TableHeaderColumn>
                <TableHeaderColumn width='92' dataField='total_price' dataFormat={formatRefundsPrice.bind(this)} >{t('orderList.totalOutstanding')}</TableHeaderColumn>
                <TableHeaderColumn width='92' dataField='total_price' dataFormat={priceFormatter.bind(this)} >{t('orderList.originalPrice')}</TableHeaderColumn>
            </BootstrapTable>}

            {!list || fetching && <p style={{textAlign: "center", fontSize:14}}><span>&nbsp;{t('orderList.loadingOrders')}</span></p>}
        </div>
    }
}

OrderList.propTypes = {
    list: PropTypes.array,
    dispatch: PropTypes.func.isRequired
}

export default injectIntl(OrderList);


// WEBPACK FOOTER //
// app/components/dashboard/OrderList.jsx